import { createApiInstance } from './index';
import { withProjectContext } from './projectContext';

const api = createApiInstance();

/**
 * 產生 CrowdStrike ISO 月報表（Word + CSV → ZIP）
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.month
 * @param {string} payload.standard
 * @param {string} payload.cloud
 * @param {string} payload.cloud_account_id
 */
export const DownloadCrowdStrikeIsoWord = (payload) => {
  return api.post('download_crowdstrike_iso_word/', payload);
};

/**
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.month
 * @param {string} payload.standard
 * @param {string} payload.cloud
 * @param {string} payload.cloud_account_id
 */
export const DownloadCrowdStrikeCisWord = (payload) => {
  return api.post('download_crowdstrike_cis_word/', payload);
};

/**
 * 產生 CrowdStrike Best Practices 月報表（暫時僅 CSV）
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.month
 * @param {string} payload.standard
 * @param {string} payload.cloud - azure | aws
 * @param {string} payload.cloud_account_id
 */
export const DownloadCrowdStrikeBestPractices = (payload) => {
  return api.post('download_crowdstrike_bp_word/', payload);
};

/**
 * 取得 CrowdStrike 雲端查詢範圍清單
 * @param {Object} payload
 * @param {string} payload.cloud - azure | gcp | aws
 * @param {string} [payload.project_uuid]
 * @param {string} [payload.scan_month]
 */
export const getCloudAccount = (payload = {}) => {
  return api
    .post('get_cloud_account/', withProjectContext(payload))
    .then((res) => res.data);
};
